import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import Level3Title from '../../../../app/common/components/title/Level3Title';

interface Gestion4GProps {
  onAccess: () => void;
}

const Gestion4G = ({onAccess}: Gestion4GProps): JSX.Element => {
  const intl = useIntl();

  return (
    <div className="row g-4 mt-1">
      <div className="col-12 col-xxl-6">
        <Card>
          <Card.Header>
            <Card.Title>
              <Level3Title title={intl.formatMessage({id: 'CONFIGURATION.TEL.GESTION'})} />
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <p>{intl.formatMessage({id: 'CONFIGURATION.TEL.GESTION.DESCRIPTION'})}</p>
            <button className="btn btn-primary" onClick={onAccess}>
              {intl.formatMessage({id: 'CONFIGURATION.TEL.GESTION.ACCESS_BUTTON'})}
            </button>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Gestion4G;
